import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { BrowserRouter } from 'react-router-dom';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import './index.css';
import i18next from './locales/config';
import reportWebVitals from './reportWebVitals';
import { ApplicationSettingsProvider } from './ApplicationSettings';
import { APPEALS_SOURCE } from './constants/constants';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <FluentProvider theme={webLightTheme}>
        <I18nextProvider i18n={i18next}>
          <ApplicationSettingsProvider source={APPEALS_SOURCE.APP_SETTINGS}>
            <App />
          </ApplicationSettingsProvider>
        </I18nextProvider>
      </FluentProvider>
    </BrowserRouter>
  </React.StrictMode >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
